export const BaseContactInfo = ({
  firstName,
  lastName,
  phoneNumber,
  email
}) => {
  return {
    firstName,
    lastName,
    phoneNumber,
    email
  }
};



// WEBPACK FOOTER //
// ./src/models/shared/baseContactInfo.js